import type { DefaultOptionType } from "antd/es/select"

// To search by name/label
export const filterOption = (
  input: string,
  option: DefaultOptionType | undefined,
) =>
  ((option?.label ?? "") as string).toLowerCase().includes(input.toLowerCase())
